import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  IMomentInstance,
  IMomentTemplate,
  isSubTaskTemplateBlock,
  RequirementType
} from '@dadohr/shared/domainTypes/experience';

export const toMomentTemplateDoc = generateToDocFn<IMomentTemplate>((m) => {
  m.categories = m.categories || [];
  m.content.blocks.forEach((b) => {
    if (isSubTaskTemplateBlock(b)) {
      // This was introduced later. People might choose to copy old templates
      // which don't have this set, which can lead to problems.
      b.requirementType = b.requirementType || RequirementType.MANDATORY;
    }
  });
  return m;
});

export const toMomentInstanceDoc = generateToDocFn<IMomentInstance>((m) => {
  return m;
});
